import { Container } from '@/components/LandingPage/Container';
import { Expandable } from '@/components/LandingPage/Expandable';
import { SectionHeading } from '@/components/LandingPage/SectionHeading';

const tableOfContents = {
  'Dostępne dla wszystkich': {
    'Wyszukiwarka publiczna wszystkich egzemplarzy': 1,
    'Generowanie własnych kodów jak w prawdziwej bibliotece': 2,
    'Bibliodesk do zarządzania książkami': 3,
    'Wgląd w życie książki po oddaniu': 4,
    'Przypomnienia do pożyczalskich o terminie zwrotu naszych książek': 5,
    'Dodawanie recenzji i ocen': 5,
    'Mapa z lokalizacją półek innych bibliofili': 6,
    'Katalogowanie błyskawiczne za pomocą kodów i Biblioteki Narodowej': 7,
  },
};

export function TableOfContents() {
  return (
    <section
      id="table-of-contents"
      aria-labelledby="table-of-contents-title"
      className="scroll-mt-14 py-16 sm:scroll-mt-32 sm:py-20 lg:py-32"
    >
      <Container>
        <SectionHeading number="1" id="table-of-contents-title">
          Wprowadzenie
        </SectionHeading>
        <p className="mt-8 font-display text-4xl font-bold tracking-tight text-slate-900">
          Pełen pakiet już po zarejestrowaniu.
        </p>
        <p className="mt-4 text-lg tracking-tight text-slate-700">
          Każdy kto do nas dołącza dostaje dostęp do oprogramowania na wyciągnięcie ręki. Wystarczy
          uruchomić stronę na smartfonie i można zacząć katalogowanie.
        </p>
        <Expandable>
          {({ isExpanded }) => (
            <>
              <ol role="list" className="mt-16 space-y-10 sm:space-y-16">
                {Object.entries(tableOfContents)
                  .slice(0, isExpanded ? undefined : 2)
                  .map(([title, pages]) => (
                    <li key={title}>
                      <h3 className="font-display text-3xl font-bold tracking-tight text-slate-900">
                        {title}
                      </h3>
                      <ol
                        role="list"
                        className="mt-8 divide-y divide-slate-300/30 rounded-2xl bg-slate-50 py-3 px-6 text-base tracking-tight sm:py-7 sm:px-8"
                      >
                        {Object.entries(pages).map(([title, pageNumber]) => (
                          <li
                            key={title}
                            className="flex justify-between py-3"
                            aria-label={`${title} on page ${pageNumber}`}
                          >
                            <span className="font-medium text-slate-900" aria-hidden="true">
                              {title}
                            </span>
                            <span className="font-mono text-slate-400" aria-hidden="true">
                              {pageNumber}
                            </span>
                          </li>
                        ))}
                      </ol>
                    </li>
                  ))}
              </ol>
              {/* <Expandable.Button>See more</Expandable.Button> */}
            </>
          )}
        </Expandable>
      </Container>
    </section>
  );
}
